import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { EN_CALENDAR, ES_CALENDAR } from "common/utils/date"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { withFormik } from "formik"
import { addLocale } from "primereact/api"
import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const FechaPagoOperacion = ({
  values,
  handleSubmit,
  onHide,
  handleChange,
  isValid,
}: {
  values: { fechaOperacion: Date; fechaEmision: Date; typeDocument: string }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: $TSMigrationFixMe
  onHide: () => void
  handleChange: () => void
  isValid: boolean
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  addLocale("es", ES_CALENDAR)
  addLocale("en", EN_CALENDAR)

  const getPrimerDiaSegunFecha = (fecha: Date): Date => {
    const nuevaFecha = new Date(fecha)

    if (nuevaFecha.getDate() <= 15) {
      nuevaFecha.setMonth(nuevaFecha.getMonth() - 1)
    }

    nuevaFecha.setDate(1)

    return nuevaFecha
  }

  const isFactura =
    values.typeDocument === TYPES_DOCUMENTOS.FACTURA ||
    values.typeDocument === TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='fechaOperacion'>
            {t("crear.facturaRec.modal.operationDateLabel")}
          </label>
          <Calendar
            id='fechaOperacion'
            name='fechaOperacion'
            value={new Date(values.fechaOperacion)}
            locale={language}
            dateFormat='dd/mm/yy'
            mask='99/99/9999'
            baseZIndex={2302}
            maxDate={new Date()}
            minDate={
              isFactura
                ? getPrimerDiaSegunFecha(values.fechaEmision)
                : undefined
            }
            onChange={handleChange}
            showIcon
          />
        </div>
      </div>
      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <ButtonPrimeReact
            className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer hover:!tw-shadow'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </ButtonPrimeReact>
          <ButtonPrimeReact
            type='submit'
            disabled={!isValid}
            className='!tw-bg-primary !tw-text-simple-10 hover:!tw-shadow hover:!tw-bg-primary-over'
          >
            {t("crear.facturaRec.modal.addButton")}
          </ButtonPrimeReact>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object({
  fechaOperacion: Yup.string().min(3).required(),
})

const FormFechaPagoOperacion = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  mapPropsToValues: ({
    fechaOperacion,
    fechaEmision,
    typeDocument,
  }: {
    fechaOperacion: Date
    fechaEmision: Date
    typeDocument: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: $TSMigrationFixMe
    onHide: () => void
  }) => {
    return {
      fechaOperacion: fechaOperacion ? new Date(fechaOperacion) : new Date(),
      fechaEmision: new Date(fechaEmision),
      typeDocument,
    }
  },
  handleSubmit: ({ fechaOperacion }, { props }) => {
    props.onChange(fechaOperacion)
    props.onHide()
  },
})(FechaPagoOperacion)

export default FormFechaPagoOperacion
